module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "06multiadmins.b77427c5.png" + "?" + Date.now();